import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { ROUTES } from '../routes';

interface GatedViewProps {
  viewName: string;
  description: string;
  requiredPlan: 'Pro' | 'Max';
  comingSoon?: boolean;
  icon?: React.ComponentType<{ className?: string }>;
}

export function GatedView({
  viewName,
  description,
  requiredPlan,
  comingSoon = false,
  icon: Icon,
}: GatedViewProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const DisplayIcon = Icon ?? Sparkles;

  return (
    <div className="flex-1 flex items-center justify-center p-8">
      <div className="max-w-md text-center">
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 rounded-full bg-indigo-500/10 flex items-center justify-center">
            <DisplayIcon className="w-8 h-8 text-indigo-400" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-xl font-bold text-zinc-100 mb-3">
          {comingSoon
            ? t('limits.gated_coming_soon', { view: viewName })
            : t('limits.gated_plan_required', { view: viewName, plan: requiredPlan })}
        </h1>

        {/* Description */}
        <p className="text-sm text-zinc-400 leading-relaxed mb-3">{description}</p>

        {comingSoon ? (
          <p className="text-xs text-zinc-500 mb-8">
            {t('limits.gated_note', { plan: requiredPlan })}
          </p>
        ) : (
          <div className="mb-8" />
        )}

        {/* CTA */}
        {!comingSoon && (
          <button
            type="button"
            onClick={() => navigate(ROUTES.subscription)}
            className="inline-flex items-center gap-2 py-2.5 px-6 rounded-xl bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-semibold transition-colors cursor-pointer"
          >
            {t('limits.gated_discover_plan', { plan: requiredPlan })}
          </button>
        )}
      </div>
    </div>
  );
}
